import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TressButton from "@/components/TressButton.vue";
import IconClose from "@/components/icons/IconClose.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TressCloseButton',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TressButton, { class: "button--icon button--filled close-button" }, {
    default: _withCtx(() => [
      _createVNode(IconClose, { class: "close-button__icon" })
    ]),
    _: 1
  }))
}
}

})